import Permissions from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import paths from '@app/src/wf-constants/paths'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './MenuWrapper'
import { MenuLinkWrapper } from './MenuWrapper'

const dashboardActivePaths = [
  paths.dashboard,
  paths.sourcingDashboard,
  paths.investmentDashboard,
  paths.financeDashboard,
  paths.transparencyDashboard,
]

const DashboardLink: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.dashboard,
    permission: [
      Permissions.TRANSPARENCY_USER,
      Permissions.SOURCING_USER,
      Permissions.FINANCE_USER,
      Permissions.INVESTMENT_USER,
    ],
  }

  return (
    <MenuLinkWrapper
      icon={icon}
      menuItems={menuItems}
      activePaths={dashboardActivePaths}
      title={formatMessage({ id: 'general.home' })}
    />
  )
}

export default DashboardLink
